<template>
  <div>
    <section class="section-tnc" v-if="false">
      <div class="container">
        <div class="section-space-50"></div>
        <div class="section-header-title">Terms and Conditions</div>
        <div class="section-space-25"></div>
        <p>
          By accessing and using this website the user accepts and agrees to be
          bound by the Terms and Conditions. Users should check for current
          Terms and Conditions as these can be updated and changed from time to
          time.
        </p>

        <div>
          <div class="font-weight-bold">Definitions</div>
          <!-- v-for="(refunds, refundsKey) in 5" :key="refundsKey" -->
          <ul class="p-4">
            <li>
              <p>
                MIRAJ means and includes all the brands working under the head
                of MIRAJ Limited.
              </p>
              <p>
                User means the person accessing the website and availing the
                online booking facility.
              </p>
              <p>
                Customer includes all the patrons of MIRAJ and also includes the
                user defined above.
              </p>
              <p>Website means www.Mirajcinemas.com.</p>
            </li>
          </ul>
        </div>

        <div>
          <div class="font-weight-bold">Purchasing tickets online</div>
          <ul class="p-4">
            <!-- v-for="(refunds, refundsKey) in 5" :key="refundsKey" -->
            <li>
              <p>
                Children aged 3 years and above will require a separate
                ticket.Only UP Locations Ticket is compulsory for children of 5
                years & above
              </p>
              <p>
                The 3D glasses will be available at the cinema for 3D films and
                must be returned before you exit the premises. 3D Glasses are
                chargeable (refundable/non-refundable) as per individual cinema
                policies.
              </p>
              <p>
                Items like laptop, cameras, knifes, lighter, match box,
                cigarettes, firearms and all types of inflammable objects are
                strictly prohibited.
              </p>
              <p>
                Items like carrybags eatables, helmets, handbags are not allowed
                inside the theaters are strictly prohibited. Kindly deposit at
                the baggage counter of mall/ cinema.
              </p>
            </li>
          </ul>
        </div>

        <div>
          <div class="font-weight-bold">Booking of Tickets</div>
          <ul class="p-4">
            <!-- v-for="(refunds, refundsKey) in 5" :key="refundsKey" -->
            <li>
              <p>
                The user must provide MIRAJ with the correct information
                pertaining to the cardholders name, card type, the card number,
                the card expiry date and the security code on the back of the
                card (if any) in order to make payment to MIRAJ Cinemas. The
                user shall be responsible for the correctness of the information
                provided and shall not be indemnified if the information is
                wrongly entered whether intentional or unintentional.
              </p>
              <p>
                The user must ensure the correctness of all details of the
                booking before finally booking their tickets as MIRAJ will
                accept no responsibility and will not issue a refund for wrong
                bookings that are the fault of the user. If the user experiences
                problems with the booking process, they are to call the helpline
                number of MIRAJ specified on the booking page. The Portal shall
                not cancel any bookings once the transaction is completed.
              </p>
              <p>
                Once the booking has been processed, the user will receive a
                confirmation e-mail to their e-mail address with all the
                relevant details of their booking. MIRAJ is not responsible and
                will not issue a refund to the user for selecting the wrong
                tickets or if the user does not meet the minimum age
                requirements for that particular film. The online booking is non
                transferable and cannot be further sold.
              </p>
              <p>
                To collect the tickets the user must present the credit/debit
                card that was used to book the tickets in that particular
                cinema. The user has to carry the print out of the confirmation
                mail. The user may procure the ticket from the automatic ticket
                collection points or they can present the print out to the MIRAJ
                representative at the ticket counter of the concerned Cineplex.
                The user shall also carry proof of age for movies certified 'A'.
              </p>
              <p>
                Unless specified otherwise User is subscribed to MIRAJ & MIRAJ
                Partner promotions related communication through SMS & Email.
              </p>
            </li>
          </ul>
        </div>

        <div>
          <div class="font-weight-bold">Cancellation of tickets</div>
          <p>
            The booking shall be deemed to be cancelled in the following
            circumstances:-
          </p>
          <ul class="p-4">
            <li>
              The booking is valid only for the viewing of the film at a
              specified multiplex of MIRAJ. The booking shall become valueless
              and non refundable if not used on the date specified on its face.
            </li>
            <li>
              If, in the opinion of a representative of the MIRAJ, the user is
              in breach of these Online Booking Terms or is under the influence
              of drugs or alcohol, or that it is necessary for the safety or
              comfort or security of other customers or for the protection of
              property, the representative reserves the right to refuse the
              entry or request the Customer to leave the multiplex and may if
              necessary physically remove the Customer from the multiplex or
              physically restrain the Customer.
            </li>
            <li>
              MIRAJ is required to abide by and enforce the age restrictions as
              specified by the Law for the time being in force. In the event
              that an authorised MIRAJ representative is of the opinion that the
              user does not meet the minimum age requirement and the user cannot
              provide photographic proof that they are of the required age,
              MIRAJ will not permit entry to that performance or film.
            </li>
            <li>
              The customer has an option to cancel the ticket booked online
              on www.Mirajcinemas.com.., MIRAJ mobile App, in.bookmyshow.com or
              BookMyShow App on the terms as mentioned herein-below. However, no
              ticket and F& B cancellation will be entertained once patron
              enters the cinema premises. This facility is currently only
              available in all theatres barring MIRAJ Opulent.
            </li>
            <li>
              Users can cancel tickets only 5 times every quarter. Post that
              their profile will be blocked from making further cancellations
              until the start of the next quarter.
            </li>
            <li>
              Users can contact MIRAJ customer care for authentication to get
              their profiles unlocked.
            </li>
          </ul>
        </div>

        <div>
          <div class="font-weight-bold">
            Unlocking may take upto 7 business days
          </div>
          <ul class="p-4">
            <!-- v-for="(refunds, refundsKey) in 5" :key="refundsKey" -->
            <p>Terms of cancellation are as follows:</p>
            <ul>
              Transaction can be cancelled only after 10 minutes of booking the
              ticket/F&B.
            </ul>
            <ul>
              No cancellation will be allowed within 20 minutes and movie start
              time.
            </ul>
            <ul>
              For tickets cancelled 2 hours before show start time, 75% of
              ticket value and 100% of F&B value will be refunded
            </ul>
            <ul>
              For tickets cancelled from 20 mins to 2 hours before show start
              time, 50% of ticket value, 100% of F&B value will be refunded
            </ul>
            <ul>
              In case of F&B booking (without ticket) through any mode, there is
              no cancellation available.
            </ul>
            <ul>
              No refund will be given for booking done through or amount paid by
              M-coupon/Gift card/Star Pass/Voucher/Promo. Also ticket
              cancellation cannot be applied/clubbed on a booking done through
              or an offer given by us or facilitate for business partner.
            </ul>
            <ul>
              No partial cancellation is allowed. The patron will have to cancel
              the complete transaction.
            </ul>
            <ul>
              Convenience fee and taxes applicable thereon will not be refunded
              in case of cancellation
            </ul>
            <ul>
              The refund for the cancelled ticket will be processed in minimum 7
              working days.
            </ul>
          </ul>
        </div>
        <p>
          This is an offer / facility given by Company, which can be withdrawn
          anytime without giving prior intimation to patron.
        </p>
        <div>
          <div class="font-weight-bold">General Conditions</div>
          <ul class="p-4">
            <!-- v-for="(refunds, refundsKey) in 5" :key="refundsKey" -->
            <p>
              MIRAJ will do everything possible to ensure the show and operating
              times of the cinema are true to the advertisements. However due to
              circumstances beyond MIRAJ's control there may be times that a
              film has to be cancelled or shown at a different time. In this
              instance the user may be given a refund of the ticket only. The
              mode of refund shall be at the sole discretion of MIRAJ. If any
              show is cancelled or cancellation is done from the management of
              MIRAJ then the formalities for the same will be taken in to
              consideration. The user agrees not to bring in any action against
              MIRAJ in such instance.
            </p>
            <p>
              The user who has booked for a movie certified as 'A', must provide
              MIRAJ Cinemas with the relevant proof of entitlement when the
              tickets are being collected or upon entry to the cinema.
            </p>
            <p>
              The Company reserves its rights to suspend the operations of any
              Cineplex/ Multiplex/Audi due to some exigencies and any offer,
              scheme, promotions shall not be valid/ applicable in respect of
              such Multiplex/ Cineplex/ Audi. The Company shall not be liable
              for any losses/ damages arising \ connected with such suspension.
              This clause shall also be applicable and binding on all Company's
              agents, partners and agents, partners of its affiliate/ group
              companies.
            </p>
          </ul>
        </div>
        <div>
          <div class="font-weight-bold">Warranties and Indemnification</div>
          <ul class="p-4">
            <!-- v-for="(refunds, refundsKey) in 5" :key="refundsKey" -->
            <p>
              The user represents that he/she is of sufficient legal age to use
              this service, and he/she possess the legal right and ability to
              create binding obligations for any liability he/she may incur as a
              result of the use of this service.
            </p>
            <p>
              The user understands that he/she is financially responsible for
              all uses of this service by him/her and those using his/her login
              information. The user will supervise all usage of the booking
              facility under his/her name or account.
            </p>
            <p>
              The user warrants that all information supplied by him/her and
              members of his/her household in using the booking facility are
              true and accurate.
            </p>
          </ul>
        </div>
        <div class="section-space-50"></div>
      </div>
    </section>
    <section class="section-tnc">
      <div class="container">
        <div class="section-space-50"></div>
        <div class="section-header-title">Terms and Conditions</div>
        <div class="section-space-25"></div>
        <div v-html="html"></div>
        <div class="section-space-50"></div>
      </div>
    </section>
  </div>
</template>
<script>
import MasterService from "@/apiServices/MasterService";
export default {
  data() {
    return {
      html: null,
    };
  },
  beforeMount() {
    this.getPageData();
  },
  methods: {
    async getPageData() {
      const { data } = await MasterService.GetPageData({
        page_code: "terms_and_conditions",
      });
      if (data && data.status) {
        this.html = data.data.page_data;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/termsAndConditions.vue